export default __webpack_public_path__ + "static/media/3-line-16x12px.b22fe3f2.svg";